import React, { useEffect, useState } from 'react';
import AdminNavbar from '../Navbar/AdminNavbar'
import { CButton, Loading } from '../../Components'
import { Form, FormGroup } from "react-bootstrap";
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { validateAuthor  } from './Validators';
import { useNavigate, useParams } from 'react-router-dom';
import { urlPrefix } from '../../Helpers/Common';
import { adminCreateAuthor, getAdminAuthors } from '../Services/Author';

const EditAuthor = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: "",
            description: ""
        },
        validate: validateAuthor,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true)
            let result = await adminCreateAuthor({...values,id});
            result?.success ? toast.success(result.message) : toast.error(result?.error?.message)
            navigate(urlPrefix() + "/admin/authors")
            setLoading(false)
        }
    });

    const errorElement = (msg) => {
        return <div className='small text-danger'>{msg}</div>
    }


    const getInitialPageData = async() => {
        setLoading(true);
        let result = await getAdminAuthors({ filters: { authors: [id] } });
        setLoading(false)
        if (result?.success) {
            formik.setValues(result.data[0])
        } else {
            navigate( urlPrefix() + "/admin/authors")
        }
    }   

    useEffect(()=>{
        getInitialPageData()
    },[])


    return (
        <div className="admin-panel-main">
            <div className="panel-row">
                <div className="left">
                    <AdminNavbar></AdminNavbar>
                </div>
                <div className="right">

                    <div className="add-book">
                        <div className="panel-title-top">
                            <div className="top-left">
                                <button className='top-back-12' onClick={() => navigate(urlPrefix() + "/admin/authors/")}>Back</button>
                                <h3 className="heading-h3">Edit Author</h3>
                            </div>
                            <div className="top-right">
                                <div className="right-side">
                                    {/* <CButton label="Add Book" custClassName="login-button t-btn"></CButton> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="add-book-form">
                        <Form className="book-panel-form" onSubmit={formik.handleSubmit}>
                            <div className="pan-form-row">

                                <div className="cost-form-input">
                                    <FormGroup className="cost-form-group">
                                        <Form.Label>Name:</Form.Label>
                                        <input
                                            id="name"
                                            name="name"
                                            type="name"
                                            onChange={formik.handleChange}
                                            value={formik.values.name}
                                            placeholder=""
                                            className="form-control"
                                            autoComplete="new-password"
                                        />
                                        {formik.errors.name ? errorElement(formik.errors.name) : null}
                                    </FormGroup>
                                </div>

                                <div className="cost-form-input">
                                    <FormGroup className="cost-form-group">
                                        <Form.Label>Description:</Form.Label>
                                        <input
                                            id="description"
                                            name="description"
                                            type="description"
                                            onChange={formik.handleChange}
                                            value={formik.values.description}
                                            placeholder=""
                                            className="form-control"
                                            autoComplete="new-password"
                                        />
                                        {formik.errors.description ? errorElement(formik.errors.description) : null}
                                    </FormGroup>
                                </div>

                            </div>
                            <div className="submit-cta">
                                <CButton label="Submit" type="submit" custClassName="login-button t-btn"></CButton>
                            </div>

                        </Form>
                    </div>

                </div>
            </div>
            {
                loading ? <Loading /> : null
            }
        </div>
    )
}

export default EditAuthor